module.exports = __webpack_public_path__ + "assets/01.a72a64a0.pdf";